import React from "react";

/**
 * Self-contained fallback when a deploy leaves the tab on stale assets.
 * No lazy imports, icon fonts, images, or SCSS - must never throw.
 */
const WHATSAPP_URL = "https://wa.me/+27663784460";

const COLORS = {
  slate: "#4f6367",
  ink: "#2c3e40",
  orange: "#f17516",
  paper: "#eef1f2",
  border: "#e2eaea",
  card: "#ffffff",
  page: "#f4f7f7",
};

export default function ChunkErrorFallback({ onReload }) {
  const handleReload = () => {
    if (typeof onReload === "function") {
      onReload();
      return;
    }
    window.location.reload();
  };

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        overflowY: "auto",
        backgroundColor: COLORS.page,
        fontFamily:
          "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        color: COLORS.ink,
      }}
    >
      <div
        style={{
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "32px 20px 48px",
          boxSizing: "border-box",
        }}
      >
        <a
          href="/"
          aria-label="QikTruck home"
          style={{
            textDecoration: "none",
            marginBottom: "28px",
            fontSize: "22px",
            fontWeight: 800,
            letterSpacing: "-0.02em",
          }}
        >
          <span style={{ color: COLORS.orange }}>Qik</span>
          <span style={{ color: COLORS.slate }}>Truck</span>
        </a>

        <div
          style={{
            width: "100%",
            maxWidth: "440px",
            backgroundColor: COLORS.card,
            borderRadius: "16px",
            border: `1px solid ${COLORS.border}`,
            boxShadow: "0 8px 32px rgba(44, 62, 64, 0.08)",
            padding: "32px 24px 28px",
            textAlign: "center",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: 64,
              height: 64,
              margin: "0 auto",
              borderRadius: "50%",
              backgroundColor: COLORS.paper,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              color: COLORS.orange,
              fontWeight: 700,
            }}
            aria-hidden="true"
          >
            ↻
          </div>

          <h1
            style={{
              margin: "20px 0 10px",
              fontSize: "clamp(22px, 4vw, 26px)",
              fontWeight: 700,
              lineHeight: 1.25,
              color: COLORS.ink,
            }}
          >
            Update available - refresh to continue
          </h1>

          <p
            style={{
              margin: "0 0 24px",
              fontSize: "16px",
              lineHeight: 1.55,
              color: COLORS.slate,
            }}
          >
            We&apos;ve rolled out a new version of the business portal. Refresh
            once to load it and continue where you left off.
          </p>

          <button
            type="button"
            onClick={handleReload}
            style={{
              display: "inline-block",
              width: "100%",
              maxWidth: "280px",
              padding: "14px 24px",
              fontSize: "16px",
              fontWeight: 600,
              cursor: "pointer",
              backgroundColor: COLORS.orange,
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(241, 117, 22, 0.35)",
            }}
          >
            Refresh page
          </button>

          <p
            style={{
              margin: "20px 0 0",
              fontSize: "14px",
              lineHeight: 1.5,
              color: COLORS.slate,
            }}
          >
            Need help?{" "}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: COLORS.orange,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              WhatsApp us
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
